<template>
    <div class="user-role-badge d-flex justify-content-start">
        <template v-if="disabled">
            <b-badge variant="danger">DISABLED</b-badge>
        </template>
        <template v-else>
            <b-badge>{{roleText}}</b-badge>
            <b-badge v-if="isEquipmentOwnerAdmin"
                     class="badge-contractor-role d-inline-block" variant="info"
                     title="Equipment Owner Admin">
                EO ADMIN
            </b-badge>
        </template>
    </div>
</template>

<script>
export default {
    name: "UserRoleBadge",
    props: {
        user: Object, //Can pass either user or role string
        role: String,
    },
    computed: {
        userRole() {
           return this.user && this.user.role ? this.user.role : this.role
        },
        roleText() {
            if(this.userRole === 'EQUIP_OWNER' || this.userRole === 'EQUIP_OWNER_ADMIN') {
                return 'Contractor'
            } else {
                return this.userRole?.replace('_', ' ')
            }
        },
        isEquipmentOwnerAdmin() {
            return this.userRole === 'EQUIP_OWNER_ADMIN'
        },
        disabled() {
            return this.user && this.user.disabled
        }
    }
}
</script>

<style lang="scss">
    .user-role-badge {
        @media (max-width:1100px) {
            flex-direction:column;
            .badge-contractor-role {
                margin-top:.5em;
            }
        }
        @media (min-width:1101px) {
            .badge-contractor-role {
                margin-left:.5em;
            }
        }
    }
</style>
